import { render, staticRenderFns } from "./allocationStorehouse.vue?vue&type=template&id=5f3b6fda&scoped=true"
import script from "./allocationStorehouse.vue?vue&type=script&lang=js"
export * from "./allocationStorehouse.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouse.vue?vue&type=style&index=0&id=5f3b6fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b6fda",
  null
  
)

export default component.exports